var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.103a5.01 5.01 0 0 0-5 5c0 .774.316 1.621.754 2.516.437.898 1.008 1.836 1.582 2.691 1.14 1.715 2.277 3.11 2.277 3.11l.387.476.387-.476s1.136-1.395 2.281-3.11c.57-.855 1.14-1.793 1.578-2.691.438-.895.754-1.742.754-2.516 0-2.754-2.246-5-5-5Zm0 1c2.215 0 4 1.786 4 4 0 .47-.246 1.246-.652 2.079-.407.835-.961 1.742-1.512 2.578-.918 1.375-1.543 2.133-1.836 2.5-.293-.367-.918-1.125-1.836-2.5-.55-.836-1.105-1.743-1.512-2.578C4.246 7.349 4 6.572 4 6.103c0-2.214 1.785-4 4-4Zm0 3c-.55 0-1 .45-1 1 0 .551.45 1 1 1s1-.449 1-1c0-.55-.45-1-1-1Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export default ForwardRef;